/**
 * The locales the app ships in.
 *
 * Same list as `i18n/routing.ts`: the cabinet ships `ru` alongside `uz` and
 * `en`, so every route under `/<locale>/` renders in all three. It stays a
 * separate constant because the *app* list is what decides which locales
 * are offered in the switcher and pre-rendered — routing is free to accept
 * a locale the UI does not offer, and has done before (D-04).
 *
 * Ordered as the switcher reads it, matching the design system's
 * `LANGUAGES`, because `AppHeader` and `SettingsForm` render this list.
 */
import type {Locale} from './api/types'

export const APP_LOCALES: Locale[] = ['uz', 'ru', 'en']

export const APP_FALLBACK_LOCALE: Locale = 'uz'
